{
  "outbound": {
    "enabled": true,
    "url": "https://novel.r18hakadoru.ai/",
    "label": "姉妹サイト: R18 小説"
  },
  "interstitial": {
    "enabled": true,
    "url": "https://novel.r18hakadoru.ai/",
    "headline": "R18 小説サイト、公開中",
    "body": "パズルの絵で妄想がはかどったら、姉妹サイトで R18 小説を生成してみよう。",
    "linkLabel": "novel.r18hakadoru.ai を開く"
  },
  "social": {
    "enabled": true,
    "url": "https://x.com/asalabo_r18",
    "label": "X @asalabo_r18",
    "lead": "新シリーズのお知らせ"
  }
}
